export const CALENDAR_TYPE = {
	users: 'users',
	trucks: 'trucks',
};
